import { Box, Chip, Typography } from "@mui/material";
import { grey } from "../../../../../theme/muiColors";
import { missingScopes } from "../../../utils";
export const Scopes = ({ scopes }: { scopes?: string[] }) => {
  if (!scopes?.length) return null;
  const missingScopesList = missingScopes(scopes);

  return (
    <Box>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
        {scopes.map((scope) => (
          <Chip
            key={scope}
            label={scope}
            variant="outlined"
            size="small"
            sx={{
              borderColor: grey[300],
              color: grey[700],
              "& .MuiChip-label": { fontSize: "0.8125rem" },
            }}
          />
        ))}
      </Box>
      {missingScopesList.length > 0 && (
        <Typography variant="caption" sx={{ mt: 1, color: "warning.main", fontStyle: "italic", textAlign: "center" }}>
          Attention: You currently cannot receive payments due to restrictions on your PayPal account. Please reach out to PayPal Customer Support or visit https://www.paypal.com for more information.
        </Typography>
      )}
    </Box>
  );
};